export default function apiLink(value) {
  return `${process.env.VUE_APP_ROOT_API}${value}`;
}
